import Script from "next/script";
import { FC } from "react";

type JsonValue = string | number | boolean | null | JsonObject | JsonValue[];

interface JsonObject {
  "@type": string;
  [key: string]: JsonValue;
}

export type Props = {
  schemaData: JsonObject;
  id: string;
};

const StructuredData: FC<Props> = ({ schemaData, id }) => {
  return (
    <Script
      id={id}
      type="application/ld+json"
      data-testid="structured-data-script"
    >
      {JSON.stringify({
        "@context": "http://schema.org",
        ...schemaData,
      })}
    </Script>
  );
};

export default StructuredData;
